var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
  '--theme': _vm.verConfig.theme,
  '--navTheme': _vm.verConfig.navTheme,
  '--bg': _vm.verConfig.pagesBG,
  '--grey': '#b8ecff',
  '--gold': '#deb86b',
  '--black': '#000',
  '--navBg': '#7e1414',
  '--moduleColor': '#262626',
  '--hallBg': '#000',
  '--yellow': '#ffd753',
  '--light': '#fff',
  '--main_bg': '#953535',
}),attrs:{"id":"app"}},[_c('router-view'),_c('WelfareDialog',{attrs:{"content":_vm.welfareDialogContent,"msgId":_vm.messageInfo.id,"next":_vm.nextmsg,"clickOverlay":false,"backgroundImage":require('@tt/assets/home/dialog_bg.png')},on:{"read":_vm.read},model:{value:(_vm.welfareDialogShow),callback:function ($$v) {_vm.welfareDialogShow=$$v},expression:"welfareDialogShow"}}),_c('div',{staticClass:"win_content"},[_c('van-dialog',{attrs:{"close-on-click-overlay":"","confirm-button-text":_vm.$t('btn.confirm'),"confirm-button-color":"#ee0a24"},on:{"confirm":_vm.winDialogConfirm,"close":_vm.winDialogConfirm},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"win_title"},[_vm._v(_vm._s(_vm.winContent.title))])]},proxy:true}]),model:{value:(_vm.dialogContent),callback:function ($$v) {_vm.dialogContent=$$v},expression:"dialogContent"}},[_c('div',{staticClass:"win_contents",domProps:{"innerHTML":_vm._s(_vm.winContent.content)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }